import { aiAskChoice } from './aiAskChoice';
import { aiDescription } from './aiDescription';
import { aiPrompt } from './aiPrompt';
import { aiRecommendationChoice } from './aiRecommendationChoice';
import { aiResultsDraft } from './aiResultsDraft';
import { ask } from './ask';
import { description } from './description';
import { location } from './location';
import { media } from './media';
import { phoneCollection } from './phoneCollection';
import { publish } from './publish';
import { reach } from './reach';

// List of steps that will be used (ORDERED)
export const DEFAULT_CONFIG = [
	reach,
	location,
	aiPrompt,
	aiDescription,
	aiResultsDraft,
	ask,
	description,
	media,
	phoneCollection,
	publish,
];

// All configs used to filter out invalid steps (UNORDERED)
export const ALL_CONFIGS = [
	aiRecommendationChoice,
	aiAskChoice,
	aiDescription,
	aiPrompt,
	aiResultsDraft,
	ask,
	description,
	location,
	media,
	phoneCollection,
	publish,
	reach,
];
